import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Input } from '../ui/input';
import { MultiCombobox } from '../ui/multi-combobox';

interface PolicyFiltersProps {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    allTags: string[];
    selectedTags: string[];
    onTagsChange: (tags: string[]) => void;
}

export function PolicyFilters({
    searchTerm,
    onSearchChange,
    allTags,
    selectedTags,
    onTagsChange,
}: PolicyFiltersProps) {
    const { t } = useTranslation();

    return (
        <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-4">
            <div className="relative w-full sm:max-w-md">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                    placeholder={t('departmentPolicies.filters.searchPlaceholder')}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="pl-9"
                />
            </div>
            <MultiCombobox
                options={allTags}
                value={selectedTags}
                onChange={onTagsChange}
                placeholder={t('departmentPolicies.filters.tagsPlaceholder')}
                searchPlaceholder={t('departmentPolicies.filters.tagsSearchPlaceholder')}
                emptyText={t('departmentPolicies.filters.noTags')}
                className="w-full sm:w-72"
                aria-label="Filter by tag"
            />
        </div>
    );
}
